/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const sponsorRef = con.eventDB.collection(cn).doc('SponsorList').collection('Sponsors');
const storageRef = con.storageRef;
const SponsorCategoryRef = con.eventDB.collection(cn).doc('SponsorCategoryList').collection('SponsorCategory');
const fetchSponsorCategoryRef = con.eventDB.collection(cn).doc('SponsorCategoryList').collection('SponsorCategory').orderBy("CategoryPriority");
var SponserVisitFetchAPI = con.SponserVisitFetchAPI;
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
    addSponsorCategory(context, field) {
        //console.log(atob(field.id));
        //console.log(field); 

        return new Promise((resolve, reject) => {
            let AutoID = "SPC" + new Date().getTime();
            let docObj = {
                CreatedBy: '',
                CreatedDate: new Date(),
                CategoryID: AutoID,
                CategoryName: field.CategoryName.trim(),
                CategoryColor: field.CategoryColor.trim(),
                LogoSize: field.LogoSize,
                LastModifiedDate: new Date(),
                CategoryPriority: 1 //kk
            };


            SponsorCategoryRef.get().then(querySnapshot => {
                if (querySnapshot.size) {
                    let namenotMatched = true
                    querySnapshot.docs.forEach(doc => {
                        if (doc.data().CategoryName.toLowerCase() == field.CategoryName.toLowerCase()) {
                            namenotMatched = false
                        }
                    });

                    if (namenotMatched) {
                        SponsorCategoryRef.doc(`${AutoID}`).set(docObj).then(function() {
                            resolve({ status: 200, message: 'Category Added.' });
                        }).catch(function(error) {
                            //console.log(error)
                            reject(error);
                        });
                    } else {
                        resolve({ status: 200, message: 'Category Already Exist!.' });
                    }

                } else {
                    //console.log("not exist doc")
                    SponsorCategoryRef.doc(`${AutoID}`).set(docObj).then(function() {
                        resolve({ status: 200, message: 'Category Added.' });
                    }).catch(function(error) {
                        //console.log(error)
                        reject(error);
                    })
                }
            }).catch(function(error) {
                reject(error);
                //console.log(error)
            });
        })
    },
    fetchSponsorCategoryDropdown({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            fetchSponsorCategoryRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ CategoryID: doc.data().CategoryID, CategoryName: doc.data().CategoryName, CategoryColor: doc.data().CategoryColor, CategoryPriority: doc.data().CategoryPriority })
                });
                commit('SET_SPONSORCATEGORY', markers);
                resolve(markers);
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error);
            })

        })
    },
    UpdateSponsorCategory(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            SponsorCategoryRef.doc(`${field.CategoryID}`).update({
                    CategoryPriority: field.CategoryPriority,
                    LastModifiedDate: new Date(),

                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' })
                        // context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {
                        //     if (field.data.file) {
                        //         const file = field.data.file
                        //         const metadata = {
                        //             'contentType': file.type
                        //         }
                        //         storageRef.child(`${cn  }/Sponsor/profileImage/${  new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function(snapshot) {
                        //             snapshot.ref.getDownloadURL().then(function(url) {
                        //                 sponsorRef.doc(`${field.id}`).update({ Logo: url.toString() }).then(function(doc) {
                        //                     resolve({ status: 200, message: 'Data & File Updated.' })
                        //                 }).catch(function(error) {
                        //                     //console.log('data update '+error)                
                        //                 })
                        //             }).catch(function(error) {
                        //                 //console.log('download url '+error)                
                        //             })
                        //         }).catch(function(error) {
                        //             //console.log('imgae upload '+error)                
                        //         })
                        //     } else {
                        //         resolve({ status: 200, message: 'Data Updated.' })
                        //     }
                        // })

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                })
        })
    },
    UpdateSponsorCategoryFiealds(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            SponsorCategoryRef.doc(`${field.CategoryID}`).update({
                    CategoryName: field.CategoryName.trim(),
                    LastModifiedDate: new Date(),

                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' })
                        // context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {
                        //     if (field.data.file) {
                        //         const file = field.data.file
                        //         const metadata = {
                        //             'contentType': file.type
                        //         }
                        //         storageRef.child(`${cn  }/Sponsor/profileImage/${  new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function(snapshot) {
                        //             snapshot.ref.getDownloadURL().then(function(url) {
                        //                 sponsorRef.doc(`${field.id}`).update({ Logo: url.toString() }).then(function(doc) {
                        //                     resolve({ status: 200, message: 'Data & File Updated.' })
                        //                 }).catch(function(error) {
                        //                     //console.log('data update '+error)                
                        //                 })
                        //             }).catch(function(error) {
                        //                 //console.log('download url '+error)                
                        //             })
                        //         }).catch(function(error) {
                        //             //console.log('imgae upload '+error)                
                        //         })
                        //     } else {
                        //         resolve({ status: 200, message: 'Data Updated.' })
                        //     }
                        // })

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                })
        })
    },
    DeleteSponsorCategory(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            SponsorCategoryRef.doc(`${field.CategoryID}`).delete()
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Deleted.' })
                        // context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {
                        //     if (field.data.file) {
                        //         const file = field.data.file
                        //         const metadata = {
                        //             'contentType': file.type
                        //         }
                        //         storageRef.child(`${cn  }/Sponsor/profileImage/${  new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function(snapshot) {
                        //             snapshot.ref.getDownloadURL().then(function(url) {
                        //                 sponsorRef.doc(`${field.id}`).update({ Logo: url.toString() }).then(function(doc) {
                        //                     resolve({ status: 200, message: 'Data & File Updated.' })
                        //                 }).catch(function(error) {
                        //                     //console.log('data update '+error)                
                        //                 })
                        //             }).catch(function(error) {
                        //                 //console.log('download url '+error)                
                        //             })
                        //         }).catch(function(error) {
                        //             //console.log('imgae upload '+error)                
                        //         })
                        //     } else {
                        //         resolve({ status: 200, message: 'Data Updated.' })
                        //     }
                        // })

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                })
        })
    }
    ,
    fetchSponsors({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            sponsorRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    markers.push(docObj)
                })
                commit('SET_SPONSORS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchSponsor(context, id) {
        //console.log(id)
        debugger
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        BoothNo: '',
                        CreatedDate: '',
                        Email: '',
                        LastModifiedDate: '',
                        Level: '',
                        Logo: '',
                        MappedContacts: [],
                        Name: '',
                        Phone: '',
                        Profile: '',
                        IsPublished: true,
                        Resources: [],
                        ShowcaseImages: [],
                        SocialLinks: [],
                        SponsorId: '',
                        Website: ''
                    }
                })
            } else {
                let docObj = new Object
                sponsorRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    //console.log(doc.data().SocialLinks[0].Facebook)
                    /*docObj.SocialLinks = {
                        Facebook: doc.data().SocialLinks[0].Facebook,
                        Twitter: doc.data().SocialLinks[3].Twitter,
                        GooglePlus: doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn: doc.data().SocialLinks[2].LinkedIn
                    }*/
                    docObj.SocialLinks = {
                        /*Facebook: doc.data().SocialLinks[0].Facebook,
                        GooglePlus: doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn: doc.data().SocialLinks[2].LinkedIn,
                        Twitter: doc.data().SocialLinks[3].Twitter  */
                    }
                    // if (doc.data().SocialLinks) {
                    //     for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                    //         let socialkeys = Object.keys(doc.data().SocialLinks[i])
                    //         let socialvaues = Object.values(doc.data().SocialLinks[i])
                    //         docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                    //     }
                    // }
                    
                    if (doc.data().SocialLinks) {
                        for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                            let socialkeys = Object.keys(doc.data().SocialLinks[i])
                            let socialvaues = Object.values(doc.data().SocialLinks[i])
                            if (socialkeys[0] && socialvaues[0])
                                docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                        }
                    }


                    docObj.Resources = (doc.data().Resources ? doc.data().Resources : [])
                        //console.log(docObj)                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateStatus(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            sponsorRef.doc(`${field.id}`).update({
                    IsPublished: field.IsPublished,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    updateSponsor(context, field) {
        debugger;
        return new Promise((resolve, reject) => {
            let docObj = {
                BoothNo: field.data.BoothNo == '' ? '': field.data.BoothNo,
                Email: field.data.Email ? field.data.Email.trim() : '',
                LastModifiedDate: new Date(),
                Level: field.data.Level == '' ? '': field.data.Level,
                //Logo: field.data.Logo == '' ? '': field.data.Logo,
                MappedContacts: field.data.MappedContacts ? field.data.MappedContacts : [],
                Name: field.data.Name ? field.data.Name.trim() : '',
                Phone: field.data.Phone == '' ? '': field.data.Phone,
                Profile: field.data.Profile == '' ? '': field.data.Profile,
                IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                Category: field.data.Category ? field.data.Category : { CategoryPriority: 0 },
                Website: field.data.Website == '' ? '': field.data.Website
            }
            if (field.data.Resources) {
                docObj.Resources = field.data.Resources.filter(function(element) {
                    return typeof element == 'string';
                });
            }
            sponsorRef.doc(`${field.id}`).update(docObj)
                .then(function(doc) {
                    context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {
                        if (field.data.file) {
                            const file = field.data.file
                            const metadata = {
                                'contentType': file.type
                            }
                            storageRef.child(`${cn}/Sponsor/Logo/${new Date().getTime()}_${file.name}`).putString(field.data.Logo, 'data_url').then(function (snapshot) {
                                snapshot.ref.getDownloadURL().then(function(url) {
                                    sponsorRef.doc(`${field.id}`).update({ Logo: url.toString() }).then(function(doc) {
                                        resolve({ status: 200, message: 'Data & File Updated.' })
                                    }).catch(function(error) {
                                        //console.log('data update '+error)                
                                    })
                                }).catch(function(error) {
                                    //console.log('download url '+error)                
                                })
                            }).catch(function(error) {
                                //console.log('imgae upload '+error)                
                            })
                        } else {
                            resolve({ status: 200, message: 'Data Updated.' })
                        }
                    })

                }).catch(function(error) {
                    console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    addSponsor(context, field) {
        console.log(field);
        return new Promise((resolve, reject) => {
            //let ExhibitorID = "EX" + new Date().getTime();
            //let ExhibitorID = context.dispatch('getAutoId');
            let docObj = {
                BoothNo: field.data.BoothNo,
                CreatedDate: new Date(),
                Email: field.data.Email.trim(),
                LastModifiedDate: new Date(),
                Level: field.data.Level,
                Logo: null,
                MappedContacts: field.data.MappedContacts ? field.data.MappedContacts : [],
                Name: field.data.Name.trim(),
                Phone: field.data.Phone,
                Profile: field.data.Profile,
                IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                // Resources:field.data.Resources ? field.data.Resources : [],
                Resources: [],
                ShowcaseImages: [],
                UserRoles: [{
                        RoleID: 10,
                        RoleName: "AppUser"
                    },
                    {
                        RoleID: 13,
                        RoleName: "Sponsor"
                    }
                ],
                SocialLinks: [
                    { Facebook: '' },
                    { Twitter: '' },
                    { GooglePlus: '' },
                    { LinkedIn: '' }
                ],
                SponsorId: null,
                Website: field.data.Website,
                Category: field.data.Category ? field.data.Category : { CategoryPriority: 0 },
            }

            context.dispatch('getAutoId').then(SponsorId => {
                docObj.SponsorId = SponsorId;
                sponsorRef.doc(`${docObj.SponsorId}`).set(docObj).then(function() {
                    context.dispatch('resourceUpload', { Id: SponsorId, files: field.data.ResourceFiles }).then(resource => {
                        if (field.data.file) {
                            const file = field.data.file
                            const metadata = {
                                'contentType': file.type
                            }
                            storageRef.child(`${cn}/Sponsor/Logo/${new Date().getTime()}_${file.name}`).putString(field.data.Logo, 'data_url').then(function (snapshot) {
                                snapshot.ref.getDownloadURL().then(function(url) {
                                    sponsorRef.doc(`${SponsorId}`).update({ Logo: url.toString() }).then(function(doc) {
                                        resolve({ status: 200, message: 'Data & File Added.', Id: SponsorId })
                                    }).catch(function(error) {
                                        //console.log('data update '+error)                
                                    })
                                }).catch(function(error) {
                                    //console.log('download url '+error)                
                                })
                            }).catch(function(error) {
                                //console.log('imgae upload '+error)                
                            })
                        } else {
                            resolve({ status: 200, message: 'Data Added.', Id: SponsorId })
                        }
                    })
                }).catch(function(error) {
                    reject(error)
                })
            });



        })
    },

    updateSponsorSocialDetail(context, field) {
        //alert(field.id)
        return new Promise((resolve, reject) => {
            sponsorRef.doc(`${field.id}`).update({
                    SocialLinks: [
                        { Facebook: (field.data.SocialLinks.Facebook ? field.data.SocialLinks.Facebook : '') },
                        { GooglePlus: (field.data.SocialLinks.GooglePlus ? field.data.SocialLinks.GooglePlus : '') },
                        { LinkedIn: (field.data.SocialLinks.LinkedIn ? field.data.SocialLinks.LinkedIn : '') },
                        { Twitter: (field.data.SocialLinks.Twitter ? field.data.SocialLinks.Twitter : '') }
                    ]
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Social Data Updated.' })
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })
        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },
    resourceUpload(context, obj) {
        return new Promise((resolve, reject) => {
            if (obj.files && obj.files.length) {
                let count = 0;
                for (var i = 0; i < obj.files.length; i++) {
                    let file = obj.files[i]
                    let metadata = {
                        'contentType': file.type
                    }
                    storageRef.child(`${cn  }/Sponsor/Resources/${  file.name}`).put(file, metadata).then(function(snapshot) {
                        snapshot.ref.getDownloadURL().then(function(url) {
                            sponsorRef.doc(`${obj.Id}`).update({ Resources: firebase.firestore.FieldValue.arrayUnion(url.toString()) }).then(function(doc) {
                                count = count + 1;
                                if (obj.files.length == count)
                                    resolve({ status: 200, message: 'Files Updated.' })
                            })
                        })
                    })
                }
            } else {
                resolve({ status: 200, message: 'Files Updated.' })
            }
        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    sponsorRef.doc(`${data.SponsorId}`)
                        .update({ IsPublished: field.Status })
                        .then(function() {

                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    deleteResource(context, field) {
        return new Promise((resolve, reject) => {
            sponsorRef.doc(`${field.id}`).update({
                Resources: firebase.firestore.FieldValue.arrayRemove(field.name)
            }).then(function(e) {
                resolve({ status: 200, message: 'resource deleted' })
            });
        })
    },
    removeRecord({ commit }, sponsoreId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/sponsore-management/sponsores/${sponsoreId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', sponsoreId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchSponserVisitorReport(context, sponserId) {
        var hours =  (5000 * 24);
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "sponsorId": sponserId,
                "numHours": hours,
                "timeZone" : Session_Event_TZ
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(SponserVisitFetchAPI, requestData, { headers: headers }).then((response) => {
                console.log(response)
                response.data.rows.map((row4) => {
                    mObj.userName = row4.userName;
                    mObj.userEmail = row4.userEmail;
                    mObj.viewDtm = row4.viewDtm;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching sponser visitor report data==:', error)
            })

        })

    },
}